

const WizardPageDataKeyPrefix = 'WPDK_';

const WizardPageDataKeysRegistry = [
    'accountClearanceData', // -> 'WPDK_accountClearanceData',
    'paymentViewType', // -> 'WPDK_paymentViewType',
    'sideBySideData', // ->  'WPDK_sideBySideData',
    'isUwLocked', // ->  'WPDK_isUwLocked',
    //
    'copySubmission', // ->  'WPDK_copySubmission',
    'landingPage', // -> 'WPDK_landingPage',
    //
    'policyDiffData', // -> 'WPDK_policyDiffData',
    'paymentPlans', // -> 'WPDK_paymentPlans',
    'paymentMethods', // -> 'WPDK_paymentMethods',
    'dueDateExt', // -> 'WPDK_dueDateExt',
    'lastExitWizardPage', // -> 'WPDK_lastExitWizardPage',
    'isQuotePageExit',
    //
    'driverCoverages', // -> 'WPDK_driverCoverages',
    //
    'yearForMakeOptions', // -> 'WPDK_yearForMakeOptions',
    'yearMakeForModelOptions', // -> 'WPDK_yearMakeForModelOptions',
    'yearMakeModelForBodyTypeOptions', // ->  'WPDK_yearMakeModelForBodyTypeOptions',
    //
    'productSelected', // ->  'WPDK_productSelected',
    'isNewAccount', // -> 'WPDK_isNewAccount'
    //
    'selectedProducerCode', // -> 'WPDK_selectedProducerCode'
    'prendingTransactions', // -> 'WPDK_prendingTransactions'
    'issuedApprovedQuotes', // -> 'WPDK_issuedApprovedQuotes'
    'externalAgencyOptions', // -> 'WPDK_externalAgencyOptions'
    'licensedAgentOptions', // -> 'WPDK_licensedAgentOptions'
    'agentStatus', // -> 'WPDK_agentStatus'
    'servicingAgentOptions', // -> 'WPDK_servicingAgentOptions'
    'externalAgencyValue', // -> 'WPDK_externalAgencyValue'
    'licensedAgentValue', // -> 'WPDK_licensedAgentValue'
    'servicingAgentValue', // -> 'WPDK_servicingAgentValue'
    //
    'accountActiveQuotes', // -> 'WPDK_accountActiveQuotes',
    'accountCompletedQuotes', // -> 'WPDK_accountCompletedQuotes',
    //
    'policyChangeSource', // ->'WPDK_policyChangeSource'
    // 'RCTCallback',  // -> 'WPDK_RCTCallback'
    'policyChangePaymentData', // -> 'WPDK_policyChangePaymentData',
    'policyChangeDocumentsData', // -> 'WPDK_policyChangeDocumentsData',
    'policyChangeNewVersionAdded', // -> 'WPDK_policyChangeNewVersionAdded'
    'haveShownPNIPopup', // -> 'WPDK_haveShownPNIPopup'
    //
    'policySummaries', // -> 'WPDK_policySummaries',
    'isDividendsAvailable', // -> 'WPDK_isDividendsAvailable'
];


// =============
/**
 * Return a map with name -> WPDK_name
 * 
 * Sample Input: 'KP_', ['key1', 'key2']
 * Sample Output: {'key1': 'KP_key1', 'key2': 'KP_key2'}
 * @returns {object}
 */
export function getKeyCacheMap(keyPrefix, keyArray) {
    const retval = {};
    keyArray.forEach((key) => {
        retval[key] = `${keyPrefix}${key}`;
    });
    return retval;
}

const WizardPageDataKeys = getKeyCacheMap(WizardPageDataKeyPrefix, WizardPageDataKeysRegistry);

export default WizardPageDataKeys;
